import { addDoc, collection, deleteDoc, doc, getDocs, query, setDoc } from 'firebase/firestore';
import { db } from './firebase';

export const getEvents = async () => {
    const q = query(collection(db, 'events'))
    const docSnap = await getDocs(q);
    const docs = docSnap.docs.map(doc => {
        return { ...doc.data(), id: doc.id }
    })
    return { data: docs, msg: '' }
}

export const _createEvent = async (payload) => {
    const collectionRef = collection(db, 'events')
    const docRef = await addDoc(collectionRef, payload)
    return { data: { ...payload, id: docRef.id }, msg: 'El evento se ha creado correctamente' }
}

export const _updateEvent = async (id, data) => {
    let docRef = doc(db, 'events', id)
    await setDoc(docRef, { ...data }, { merge: true })
    return { data: { ...data, id }, msg: 'El evento se ha actualizado correctamente' }
}

export const _deleteEvent = async (id) => {
    let docRef = doc(db, 'events', id)
    await deleteDoc(docRef)
    return { data: { id: id }, msg: 'El evento se ha eliminado correctamente' }
}
